import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { FlashMessages } from '~/FlashMessage';
import GoogleTagManager from '~/GoogleTagManager';
import { Store } from '~/Store';

interface Props {
	children: React.ReactNode;
	store: Store;
	googleTagManagerContainerId: string | null;
	onLoad(): void;
	onError(error: Error, anyArg: any): void;
}

interface State {
	error: Error | null;
}

export default class Application extends Component<Props, State> {
	static defaultProps = {
		googleTagManagerContainerId: null,
	};

	state = {
		error: null,
	};

	componentDidMount() {
		this.props.onLoad();
	}

	componentDidCatch(error: Error, errorInfo: any) {
		this.setState({ error });
		this.props.onError(error, errorInfo);
	}

	render() {
		const {
			props: { children, store, googleTagManagerContainerId },
			state: { error },
		} = this;

		if (error !== null) {
			return (
				<FlashMessages
					messages={[
						{
							key: -1,
							type: 'error',
							text: 'Something went wrong, please refresh the page.',
							dismissable: false,
						},
					]}
				/>
			);
		}

		const provider = (
			<Provider key={Math.random()} store={store}>
				{children}
			</Provider>
		);

		return googleTagManagerContainerId ? (
			<GoogleTagManager containerId={googleTagManagerContainerId}>{provider}</GoogleTagManager>
		) : (
			provider
		);
	}
}
